import { fetchOptions } from "../eventsSlice";
import useFetch from "src/shared/hooks/useFetch";
import { Events } from "../model/events";
import dayjs from "dayjs";
import deepCopy from "src/shared/util/deep-copy";
import isEmpty from "src/shared/util/is-empty";

export default function useEvents(): { data: Events } {
  const { data: _data } = useFetch<Events>(fetchOptions);
  // @ts-ignore
  let data: Events = !isEmpty(_data) ? deepCopy(_data) : {};
  if (_data) {
    const { start_date, end_date } = _data;
    (data as Events).startDate = dayjs(start_date);
    (data as Events).endDate = dayjs(end_date);
    data.startDateMs = start_date;
    data.endDateMs = end_date;
  }

  return { data };
}
